import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

import PlaylistPlayIcon from '@mui/icons-material/PlaylistPlay';
import GameTagListItem from './tagListItem';

const GameTagList = ({ isLoading, expand, tagList, curTagListIdx, checkArr, onChecked, onVideo, onTime, t }) => {
    return tagList.length > 0 ? (
        <Box
            sx={{
                backgroundColor: '#ffffff',
                borderRadius: '12px',
                overflow: 'hidden',
                boxShadow: '0 1px 3px rgba(0,0,0,0.08)'
            }}
        >
            <Box sx={{ overflowY: 'auto', maxHeight: expand ? '35vh' : '60vh' }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '1px', backgroundColor: '#f3f4f6' }}>
                    {tagList.map((tag, index) => (
                        <GameTagListItem
                            key={index}
                            item={tag}
                            isSelected={curTagListIdx === index}
                            idx={index}
                            isChecked={checkArr[index]}
                            onChecked={onChecked}
                            onShowVideo={onVideo}
                            onChangeTime={onTime}
                        />
                    ))}
                </Box>
            </Box>
        </Box>
    ) : (
        <Box
            sx={{
                backgroundColor: '#ffffff',
                borderRadius: '12px',
                minHeight: expand ? '20vh' : '40vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 1px 3px rgba(0,0,0,0.08)'
            }}
        >
            {isLoading ? (
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px' }}>
                    <CircularProgress size={40} sx={{ color: '#6366f1' }} />
                    <Typography sx={{ color: '#6b7280', fontSize: '14px' }}>{t('Loading clips...')}</Typography>
                </Box>
            ) : (
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px' }}>
                    <PlaylistPlayIcon sx={{ fontSize: 48, color: '#d1d5db' }} />
                    <Typography sx={{ color: '#9ca3af', fontSize: '15px', fontWeight: 500 }}>
                        {t('Select a category to view clips')}
                    </Typography>
                </Box>
            )}
        </Box>
    );
};

export default GameTagList;
